module.exports = __webpack_public_path__ + "media/images/home/background-blurred-oranges-bb239dfcf2f133b6e92fbf0b285e21be.jpg";